import Api from '../Api'


export class ApiRelatorio extends Api{
    constructor(){
        super()
    }
}